<template>
    <div class="container    ">
    <b-loading :is-full-page="true" v-model="isFullScreenSearching" :can-cancel="true"></b-loading>
    
        <section class="box">
            <h1 class="mt-3 mb-3 is-size-3">OPD information</h1>

          <div class="columns is-size-4">
						<div class="column has-text-centered  ">
							<div class="box  has-text-grey">
                                OPD No.
                            </div>
						</div>
						<div class="column">
							<div class="box">{{HNSelected.idopd}}</div>
						</div>
		</div>


        <div class="columns is-size-4">
						<div class="column has-text-centered  ">
							<div class="box has-text-grey">
                                OPD Name
                            </div>
						</div>
						<div class="column">
							<div class="box">{{HNSelected.name}}</div>
						</div>
		</div>


        <div class="columns is-size-4">
						<div class="column has-text-centered  ">
							<div class="box has-text-grey">
                                Pet Age
                            </div>
						</div>
						<div class="column">
							<div class="box">{{HNSelected.age}}</div>
						</div>
		</div>

        <div class="columns is-size-4">
						<div class="column has-text-centered  ">
							<div class="box has-text-grey">
                                Species
                            </div>
						</div>
						<div class="column">
							<div class="box">{{HNSelected.species}}</div>
						</div>
		</div>

        <div class="columns is-size-4">
						<div class="column has-text-centered  ">
							<div class="box has-text-grey">
                                Breed
                            </div>
						</div>
						<div class="column">
							<div class="box">{{HNSelected.breed}}</div>
						</div>
		</div>
        
        <div class="columns is-size-4">
						<div class="column has-text-centered  ">
							<div class="box has-text-grey">
                                Owner
                            </div>
						</div>
						<div class="column">
							<div class="box">{{HNSelected.owner_name}}</div>
						</div>
		</div>

        <div class="columns is-size-4">
						<div class="column has-text-centered  ">
							<div class="box has-text-grey">
                                Address
                            </div>
						</div>
						<div class="column">
							<div class="box">{{HNSelected.address}}</div>
						</div>
		</div>


        <div class="columns is-size-4">
						<div class="column has-text-centered  ">
							<div class="box has-text-grey">
                                Phone
                            </div>
						</div>
						<div class="column">
							<div class="box">{{HNSelected.phone_mobile}}</div>
						</div>
		</div>



          


        </section>



        <section class="box">
            <h1 class="mt-3 mb-3 is-size-3">Member information</h1>

          <div class="columns is-size-4">
						<div class="column has-text-centered  ">
							<div class="box has-text-grey">
                                Member ID
                            </div>
						</div>
						<div class="column">
							<div class="box">{{MemberSelected.member_id}}</div>
						</div>
		</div>
        <div class="columns is-size-4">
						<div class="column has-text-centered  ">
							<div class="box has-text-grey">
                                Member Name
                            </div>
						</div>
						<div class="column">
							<div class="box">{{MemberSelected.name}}</div>
						</div>
		</div>
        <div class="columns is-size-4">
						<div class="column has-text-centered  ">
							<div class="box has-text-grey">
                                Address
                            </div>
						</div>
						<div class="column">
							<div class="box">{{MemberSelected.house_address}}
                                {{MemberSelected.address_txt}}
                                {{MemberSelected.tumbon_txt}}
                                {{MemberSelected.ampur_txt}}
                                {{MemberSelected.province_txt}}
                            </div>
						</div>
		</div>
        <div class="columns is-size-4">
						<div class="column has-text-centered  ">
							<div class="box has-text-grey">
                                Phone
                            </div>
						</div>
						<div class="column">
							<div class="box">{{MemberSelected.phone1}}
                            </div>
						</div>
		</div>

 



          


        </section>

        <section class="box">
          <h1 class="mt-3 mb-3 is-size-3">Items information</h1>
          <div class="columns is-size-4">
						<div class="column has-text-centered  ">
							<div class="box has-text-grey">
                               Automate Or NonAutomate
                            </div>
						</div>
						<div class="column">
							<div class="box">{{automateOrNoneAutomateMode == 0 ? 'Automate' : 'Non Automate'}}
                            </div>
						</div>
          </div>          


 

									<table class="table" width="100%">
											<thead>
												<tr>
												<th>รหัส</th>
												<th>รายการ</th>
												<th>จำนวน</th>
												<th>หน่วยนับ</th>
												<th>ราคาต่อหน่วย</th>
												<th>ราคา</th>
												</tr>
											</thead>
  <tfoot>
  <tr>
												<th></th>
												<th></th>
												<th></th>
												<th></th>
												<th></th>
												<th> <span class="has-text-weight-bold">{{formatStringToCurrency(sumPrice)}}</span> </th>
												</tr>
  </tfoot>


											<tbody>
												<tr  v-for="itemsselected in ItemsSelected" :key="itemsselected.id">
													<td>{{itemsselected.idpart}}</td>
													<td>{{itemsselected.descp}}</td>
													<td>{{formatStringToCurrency(itemsselected.amount)}}</td>
													<td>{{itemsselected.unit}}</td>
													<td>{{formatStringToCurrency(itemsselected.sell_price)}}</td>
													<td>{{formatStringToCurrency(itemsselected.amount * itemsselected.sell_price)}}</td>
												</tr> 				
											</tbody>
  </table>   
                              
 



        </section>

	<b-button type="is-primary" 
	icon-left="upload"
	@click="save"
	expanded>Confirm to Save</b-button>

   
       <!-- {{HNSelected}}<br/><br/><br/><br/>
       {{MemberSelected}}<br/><br/><br/><br/>
       {{automateOrNoneAutomateMode}}<br/><br/><br/><br/> -->
       <!-- {{ItemsSelected}}<br/><br/><br/><br/> -->

 

    </div>
</template>


<script>
import { mapState  } from "vuex";
import formatStringToCurrency from '../../mixins/methods/formatStringToCurrency'
import { getBaseURLforBackEnd , getConfigAxios   } from '@/utils.js'
import axios from "axios"

export default {
    name : "FinishCreatePathoService",
	mixins:[formatStringToCurrency,],
    mounted(){
      //  console.log("FinishCreatePathoService mounted")
    },
    computed:{
            ...mapState({
				access_token: state => state.master_data.access_token ,

                HNSelected : state => state.patho_opd_job_worklist.HNSelected ,
                MemberSelected : state => state.patho_opd_job_worklist.MemberSelected ,
                automateOrNoneAutomateMode: state => state.patho_opd_job_worklist.automateOrNoneAutomateMode ,
                ItemsSelected: state => state.patho_opd_job_worklist.ItemsSelected ,
            }) ,
            sumPrice(){
				return this.ItemsSelected.map(dat=>dat.sell_price*dat.amount)
				.reduce((acc,cur)=>acc+cur , 0) 
				}

    },
	methods:{
		save(){

// createpathoservices_noneautomate
//  {
//      "opd_no" : "58002007",
//      "member_id" : 3,
//      "part" : [{"idpart":"000000000004","amount":"1","grp":3},
//                 {"idpart":"000000000005","amount":"1","grp":4}             
//               ]
//  }




// createpathoservices_automate
//  {
//      "opd_no" : "65003516",
//      "member_id" : 1,
//      "part" : [{"idpart":"000000000009","amount":"1","grp":1} 
//               ]
//  }


// [ { "id": 7, "idpart": "000000000007", "descp": "ตรวจ CBC ทั่วไป", "unit": "ครั้ง", "sell_price": 300, "idgrp": 3, "amount": 1 }, { "id": 8, "idpart": "000000000008", "descp": "ตรวจ CBC พิเศษ", "unit": "ครั้ง", "sell_price": 350, "idgrp": 3, "amount": 1 }, { "id": 9, "idpart": "000000000009", "descp": "ตรวจ CBC + Bl. chem", "unit": "ครั้ง", "sell_price": 150, "idgrp": 3, "amount": 1 } ]
        this.isFullScreenSearching = true 
        let endPoint = this.automateOrNoneAutomateMode == 0 ? 'createpathoservices_automate' : 'createpathoservices_noneautomate'
		let partArr =  this.ItemsSelected.map(dat=>{
		return  {"idpart": dat.idpart,
		"amount": dat.amount,
		"grp":  dat.idgrp}
		})
		let datTo = {
		"opd_no" : this.HNSelected.idopd,
        "member_id" : this.MemberSelected.id, // not  this.MemberSelected.member_id cause in database id-->map-->member_id
		"part" : partArr
		}

        console.log(JSON.stringify(datTo))
		axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
		axios.post(`${getBaseURLforBackEnd()}/api/${endPoint}`,datTo,getConfigAxios())
			.then((res)=>{
				this.$emit('saveNewCheckinCompleted',res.data)
				this.isFullScreenSearching = false
            })
			.catch(err=>{
                        this.isFullScreenSearching = false
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: `Error  from ${err}`,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'alert-circle',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                    })
		}
	},
	data(){
		return{
			isFullScreenSearching : false,
		}
	}
}
</script>